import type { PuzzleData, TaskType } from '../types';
import { generateColorSequence } from './ColorSequence';
import { generateShapeMatch } from './ShapeMatch';
import { generatePatternGrid } from './PatternGrid';
import { generateSignalFlow } from './SignalFlow';
import { generateSymmetry } from './Symmetry';

export type PuzzleResult = PuzzleData & {
  referenceLabel: string;
  outputLabel: string;
};

const generators: Record<string, (complexity: number, subtlety: number) => PuzzleResult> = {
  'color-sequence': generateColorSequence,
  'shape-match': generateShapeMatch,
  'pattern-grid': generatePatternGrid,
  'signal-flow': generateSignalFlow,
  'symmetry': generateSymmetry,
};

export function generatePuzzle(type: TaskType, complexity: number, subtlety: number): PuzzleResult {
  const gen = generators[type] || generateColorSequence;
  return gen(complexity, subtlety);
}
